<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text first-installation-dialog__title">
      <h2>{{ 'signatures.firstInstallation.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="success-info">
      <div class="checkmark-circle">
        <div class="checkmark"></div>
      </div>
      <p>{{ 'signatures.firstInstallation.message' | translate }}</p>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'signatures.firstInstallation.close' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="goToEmployees()">
      <mat-icon>people</mat-icon>
      {{ 'signatures.firstInstallation.goToEmployees' | translate }}
    </button>
  </footer>
</div>
